// extracted by mini-css-extract-plugin
module.exports = {"errorPageWrapper":"styles_errorPageWrapper__Jyc0S","errorHeading":"styles_errorHeading__lS9hY","upsell":"styles_upsell__mMHCM"};